import { Component, OnInit } from '@angular/core';
import {RatingsPageService} from "../../../services/ratings-page.service";
import {RatingEditorService} from "../../../services/rating-editor.service";
import {type} from "os";
import {cloneDeep} from "lodash";

@Component({
  selector: 'app-rating-editor-balls-distribution',
  templateUrl: './rating-editor-balls-distribution.component.html',
  styleUrls: ['./rating-editor-balls-distribution.component.scss']
})
export class RatingEditorBallsDistributionComponent implements OnInit {

  private _headerNames = [
    'Место от',
    'Место до',
    'Количество очков'
  ];
  private _maximalPlaceValue = 999;
  private _integerNumberRegexp = /^(0|([1-9]\d*))$/gi;
  private _integerPositiveNumberRegExp = /^([1-9]\d*)$/gi;
  private _tableContainerToScroll: HTMLElement;
  public tableHeadName = 'Распределение рейтинговых очков за места в турнирах';
  private _tableMutationObserver = new MutationObserver(
    (mutations, observer) => {
    if (mutations[0].addedNodes.length) {
      this._tableContainerToScroll.scrollTop = this._tableContainerToScroll.scrollHeight;
    }
  });

  private _identifiersBases = {
    entireContainer: 'entireCONTAINER',
    from: 'FROM',
    to: 'TO',
    balls: 'BALLS',
    delete: 'DELETE',
    add: 'ADD',
  }

  public addBallsRowButtonText = 'Добавить места для получения очков';
  constructor(
    private pageService: RatingEditorService,
  ) { }

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    this._tableContainerToScroll = document.getElementById(this._identifiersBases.entireContainer);
    this._tableMutationObserver.observe(
      this._tableContainerToScroll,
      {
        childList: true,
        subtree: true,
      }
    );
  }
  ngOnDestroy(): void {
    this._tableMutationObserver.disconnect();
  }

  get headerNames() {
    return this._headerNames;
  }

  set headerNames(value) {
    this._headerNames = value;
  }

  getTableDataToDisplay() {
    return this.pageService.ratingBallsTable;
  }

  deleteIsFeasible(): boolean {
    return this.pageService.ratingBallsTable.length > 1
  }

  deleteCertainRow(rowIndex: number) {
    if (this.deleteIsFeasible()) {
      this.pageService.someFieldWasTouched = true;
      this.pageService.ratingBallsTable.splice(rowIndex, 1);
    }
  }
  appendNewRow() {
    this.pageService.ratingBallsTable.push({
      from: 1,
      to: 1,
      balls: 10,
    });
    this.pageService.someFieldWasTouched = true;
  }

  handleIncrementDecrement(
    $event,
    rowData,
    key: string,
    oppositeKey: string,
    lessCompare=true,
  ) {

    this.pageService.someFieldWasTouched = true;

    let changedValue = $event?.target?.value;
    const matchResult = changedValue.match(this._integerPositiveNumberRegExp);

    if (!matchResult || matchResult[0] !== changedValue) {
      $event.target.value = rowData[key];
      return;
    }

    changedValue = +changedValue;

    if (lessCompare) {
      if (changedValue < rowData[oppositeKey]) {
        $event.target.value = rowData[oppositeKey];
        return;
      }
      if (changedValue > this._maximalPlaceValue) {
        $event.target.value = this._maximalPlaceValue;
        return;
      }

    } else if (changedValue > rowData[oppositeKey]) {
      $event.target.value = rowData[oppositeKey];
      return;
    }

    rowData[key] = changedValue;
  }

  handleBallsInput($event, rowData) {

    this.pageService.someFieldWasTouched = true;

    let changedValue = $event?.target?.value;

    const matchResult = changedValue.match(this._integerPositiveNumberRegExp);

    if (!matchResult || matchResult[0] !== changedValue) {
      $event.target.value = rowData?.balls;
      return;
    }
    const numericValue = +changedValue;

    if (numericValue > 99999) {
      $event.target.value = rowData?.balls;
      return;
    }

    rowData.balls = changedValue;

  }


  formIdentifier(key: string, index?: number) {
    return `${this._identifiersBases[key]}${index ?? ''}`;
  }

  deleteIconStyle(): string {
    return this.deleteIsFeasible()
      ? 'fa-solid fa-circle-xmark text-danger iconStyleItself'
      : 'fa-solid fa-circle-xmark text-muted iconStyleItself disabledCursor'
  }


}
